import EnterpriseSWIcon from "../../assets/product-list-assets/gbe-1u-2510.svg";
import type { ProductListGroup } from "../../types";

export const switchingProfessional: ProductListGroup = {
  id: "switchingProfessional",
  title: "productListGroup.switchingProfessional.title",
  seriesLabel: "modelCompare.seriesLabel.switchingProfessional",
  icon: {
    src: EnterpriseSWIcon,
    width: 24,
    height: 24,
  },
};
